/* endex-fx-perf.js — runs after ScrollTrigger loads and before endex-fx.js initialises.
   On iOS the address bar shows and hides as you scroll, which the browser reports as a resize. ScrollTrigger
   answers every resize by re-measuring every pinned section, which is the stutter and jump mid-scroll.
   ignoreMobileResize tells it to leave height-only changes on touch devices alone. */
(function(){
  if (!window.ScrollTrigger) return;
  try {
    ScrollTrigger.config({ ignoreMobileResize: true });
  } catch (e) {}
})();
